import { render, staticRenderFns } from "./DashboardPieStatistics.vue?vue&type=template&id=38ff27ce"
import script from "./DashboardPieStatistics.vue?vue&type=script&lang=js"
export * from "./DashboardPieStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports